import styled from 'styled-components';

export const QuoteWrapper = styled.main`
  background: #f7f8fa;
  color: #1f242b;
`;

export const QuoteHero = styled.section`
  background: #1f242b;
  color: #ffffff;
  padding: clamp(3rem, 7vw, 5.5rem) max(1.25rem, calc((100vw - 1180px) / 2 + 1.25rem));

  p {
    color: #60a5fa;
    font-size: 0.82rem;
    font-weight: 900;
    letter-spacing: 0;
    margin: 0 0 0.85rem;
    text-transform: uppercase;
  }

  h1 {
    color: #ffffff;
    font-size: clamp(2.05rem, 5vw, 4.2rem);
    line-height: 1.02;
    margin: 0 0 1rem;
    max-width: 850px;
    overflow-wrap: break-word;
  }

  span {
    color: #dbe4ee;
    display: block;
    font-size: 1.1rem;
    line-height: 1.75;
    max-width: 760px;
  }
`;

export const QuoteContentGrid = styled.section`
  align-items: start;
  display: grid;
  gap: 1.5rem;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 0.42fr);
  margin: 0 auto;
  max-width: 1180px;
  padding: clamp(3rem, 6vw, 5.5rem) 1.25rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const QuoteFormWrapper = styled.section`
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.08);
  min-width: 0;
  padding: clamp(1.25rem, 4vw, 2rem);
  width: 100%;
`;

export const QuoteFormTitle = styled.h2`
  color: #1f242b;
  font-size: clamp(1.55rem, 3vw, 2.35rem);
  line-height: 1.1;
  margin: 0 0 0.65rem;
  overflow-wrap: break-word;
`;

export const FormIntro = styled.p`
  color: #586271;
  line-height: 1.7;
  margin: 0 0 1.5rem;
`;

export const Form = styled.form`
  display: grid;
  gap: 1.15rem;
  min-width: 0;
  width: 100%;
`;

export const FormGrid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const FormGroup = styled.div`
  display: grid;
  gap: 0.4rem;
`;

export const Label = styled.label`
  display: block;
  color: #1f242b;
  font-size: 0.92rem;
  font-weight: 900;
`;

export const Input = styled.input`
  background: #ffffff;
  border: 1px solid #cfd6df;
  border-radius: 8px;
  color: #1f242b;
  font-size: 1rem;
  min-width: 0;
  min-height: 48px;
  padding: 0.85rem 0.95rem;
  width: 100%;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.22);
    outline: none;
  }
`;

export const TextArea = styled.textarea`
  background: #ffffff;
  border: 1px solid #cfd6df;
  border-radius: 8px;
  color: #1f242b;
  font-size: 1rem;
  min-width: 0;
  min-height: 120px;
  padding: 0.85rem 0.95rem;
  resize: vertical;
  width: 100%;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.22);
    outline: none;
  }
`;

export const HelpText = styled.span`
  color: #667085;
  font-size: 0.88rem;
  line-height: 1.5;
`;

export const RequiredNote = styled.p`
  color: #667085;
  font-size: 0.9rem;
  margin: 0;
`;

export const FormError = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #991b1b;
  font-weight: 800;
  line-height: 1.55;
  padding: 0.9rem 1rem;
`;

export const Button = styled.button`
  background-color: #2563eb;
  border: 2px solid #2563eb;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 900;
  min-height: 52px;
  padding: 0.85rem 1.2rem;
  transition: background-color 160ms ease, border-color 160ms ease, transform 160ms ease;
  width: fit-content;

  &:hover,
  &:focus-visible {
    background-color: #1d4ed8;
    border-color: #1d4ed8;
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: wait;
    opacity: 0.72;
    transform: none;
  }

  @media (max-width: 520px) {
    width: 100%;
  }
`;

export const ContactPanel = styled.aside`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.06);
  padding: 1.35rem;

  h2,
  h3 {
    color: #1f242b;
    line-height: 1.2;
    margin: 0 0 0.7rem;
  }

  h2 {
    font-size: 1.45rem;
  }

  h3 {
    font-size: 1.05rem;
    margin-top: 1.3rem;
  }

  p {
    color: #586271;
    line-height: 1.7;
    margin: 0 0 1rem;
  }

  a {
    color: #1d4ed8;
    display: block;
    font-weight: 900;
    margin-bottom: 0.65rem;
    overflow-wrap: anywhere;
    text-decoration: none;
  }

  ul {
    display: grid;
    gap: 0.45rem;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    color: #374151;
    font-weight: 800;
    padding-left: 1rem;
    position: relative;
  }

  li::before {
    background: #2563eb;
    border-radius: 999px;
    content: '';
    height: 0.42rem;
    left: 0;
    position: absolute;
    top: 0.55rem;
    width: 0.42rem;
  }
`;

export const SuccessCard = styled.section`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(17, 24, 39, 0.08);
  margin: clamp(3rem, 6vw, 5rem) auto;
  max-width: 760px;
  padding: clamp(1.5rem, 4vw, 2.5rem);
  text-align: center;

  h2 {
    color: #1f242b;
    font-size: clamp(1.8rem, 4vw, 2.6rem);
    line-height: 1.1;
    margin: 0 0 0.85rem;
  }

  p {
    color: #586271;
    line-height: 1.75;
    margin: 0 auto 1.35rem;
    max-width: 620px;
  }

  a {
    color: #1d4ed8;
    font-weight: 900;
  }

  > a {
    background: #2563eb;
    border-radius: 8px;
    color: #ffffff;
    display: inline-flex;
    justify-content: center;
    min-height: 48px;
    padding: 0.85rem 1.2rem;
    text-decoration: none;
  }

  @media (max-width: 520px) {
    margin-left: 1.25rem;
    margin-right: 1.25rem;

    > a {
      width: 100%;
    }
  }
`;
